enum InsuranceSystem {
  NICE = 'NICE',
  PARIS = 'PARIS',
  PROLIFE = 'PROLIFE',
}

export default InsuranceSystem;
